// Modules
import cn from 'classnames';

// Types
import type { TStepProps } from './Stepper.type';

// Styles
import styles from './styles/Step.module.scss';

// Components
import Icon from '../Icon/index';

// Constants
import { STEP_DEFAULT_PROPS, STEPPER_STATUS } from './Stepper.constant';

const Step = (props: TStepProps) => {
  const {
    className,
    description,
    descriptionClassName,
    descriptionStyle,
    indicator,
    indicatorClassName,
    indicatorStyle,
    labelClassName,
    labelStyle,
    orientation = STEP_DEFAULT_PROPS.orientation,
    position = STEP_DEFAULT_PROPS.position,
    status,
    textPosition = STEP_DEFAULT_PROPS.textPosition,
    title,
    titleClassName,
    titleStyle,
    ...restProps
  } = props;
  const isCompleted = status === STEPPER_STATUS.complete;

  const stepCN = cn(styles.legion_step, className, styles[position!], styles[orientation!], styles[textPosition!], styles[status!]);
  const indicatorCN = cn(styles.indicator, indicatorClassName);
  const labelCN = cn(styles.label_section, labelClassName);
  const descriptionCN = cn(styles.description, descriptionClassName);
  const titleCN = cn(styles.title, titleClassName);

  return (
    <div className={stepCN} {...restProps}>
      <div className={indicatorCN} style={indicatorStyle}>
        {isCompleted ? (
          <Icon
            icon={'check'}
            style={{
              backgroundColor: 'var(--stepper-color-success-indicator-label)'
            }}
          />
        ) : (
          indicator
        )}
      </div>
      <div className={labelCN} style={labelStyle}>
        <p className={titleCN} style={titleStyle}>
          {title}
        </p>
        <p className={descriptionCN} style={descriptionStyle}>
          {description}
        </p>
      </div>
    </div>
  );
};

Step.displayName = 'Step';
export default Step;
